import { render, staticRenderFns } from "./KidsFoundationLogo50yearsNL.vue?vue&type=template&id=bc2a61f4&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports